import { DEFAULT_BORDER } from 'constants/global';

import First from 'assets/illustrations/cooperations/mds_first.png';
import Second from 'assets/illustrations/cooperations/mds_second.png';
import Third from 'assets/illustrations/cooperations/mds_third.png';

const sxCard = {
  h: 'auto',
  minH: { tablet: '320px', laptop: '422px', desktop: '472px' },
  color: 'text.darkGray',
};

const sameFields = {
  sxCard,
  descriptionSx: { maxW: 'unset' },
  textContainerProps: { justify: 'start' },
  headerStyle: { mt: { mobile: '16px', tablet: '67px' } },
  contentContainerProps: { gap: { mg: '20px', xxl: '91px' } },
};

const cardsData = [
  {
    title: 'Сокращение издержек',
    description:
      'Заказчик оплачивает только выполненную работу и не тратит средства на аренду помещения, подбор и обучение сотрудников, износ оборудования, как это бывает в случае с собственным штатом ИТ‑специалистов',
    img: First,
    bgColor: 'bg.white',
    border: DEFAULT_BORDER,
    borderColor: 'line.gray',
    imgProps: {
      w: { tablet: '230.5px', xxl: '318px' },
      h: { tablet: '222px', xxl: '306px' },
      mt: { tablet: '29px', xxl: '-16px', desktop: '36px' },
    },
    p: {
      desktop: '48px 132px 60px 80px',
      laptop: '48px 80px 62px',
      tablet: '24px 28px 24px 32px',
      mobile: '16px 20px 24px 24px',
    },
    ...sameFields,
    contentContainerProps: { gap: { tablet: '26px', xxl: '104px' } },
  },
  {
    title: 'Фокус на главном',
    description:
      'Пока специалисты ASTON берут на себя текущие дела, вы можете направить все силы на развитие и масштабные задачи',
    img: Second,
    p: {
      desktop: '48px 119px 64px 80px',
      laptop: '48px 80px 48px',
      tablet: '24px 12px 24px 32px',
      mobile: '16px 24px 24px 24px',
    },
    imgProps: {
      w: { tablet: '272px', xxl: '344px' },
      h: { tablet: '272px', xxl: '344px' },
      mt: { tablet: '-20px', xxl: '-31px', desktop: '-6px' },
    },
    ...sameFields,
  },
  {
    title: 'Увеличение скорости внедрения',
    description:
      'Специалисты ASTON обладают большим практическим опытом разработки и внедрения решений разной сложности. Благодаря этому они быстрее сдают готовую работу и помогают вам достичь деловых целей',
    img: Third,
    p: {
      desktop: '48px 119px 64px 80px',
      laptop: '48px 80px 48px',
      tablet: '24px 12px 24px 32px',
      mobile: '16px 24px 24px 24px',
    },
    imgProps: {
      w: { tablet: '272px', xxl: '344px' },
      h: { tablet: '272px', xxl: '344px' },
      mt: { tablet: '-20px', xxl: '-31px', desktop: '-6px' },
    },
    ...sameFields,
    descriptionSx: { color: 'text.white', maxW: 'unset' },
    sxCard: { ...sxCard, bgColor: 'bg.black', color: 'text.white' },
  },
];

export const mdsCardsData = {
  title: (
    <>
      Плюсы разработки
      <br />
      под ключ
    </>
  ),
  cardsData,
  className: 'advantageDevelopment',
  showButton: false,
};
